//Operations

export enum ShipmentProductOperationEnum {
  AddShipmentProductPackage = "add-shipment-product-package",
}
